import './kiroku.css';
import * as bootstrapUtils from "react-bootstrap/es/utils/bootstrapUtils";
import {Button} from "react-bootstrap";

bootstrapUtils.addStyle(Button, 'kiroku-default');
